import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class GrnApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.GRN);
  }

  getGRNLines(grnId) {
    return this.httpClient.get(`${this.getResourceUrl()}${grnId}/lines/`);
  }

  addGRNLines(grnId, data, grnType = 'po') {
    const endpoint = grnType === 'po' ? 'po/' : 'gate-pass/';
    return this.httpClient.post(
      `${this.getResourceUrl()}${grnId}/lines/multi-add/${endpoint}`,
      data,
    );
  }

  deleteGRNLines(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/multi-remove/`,
      data,
    );
  }

  updateGRNStatus(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/status/`,
      data,
    );
  }

  getGRNPutaway(warehouseId) {
    return this.httpClient.get(`${this.getResourceUrl()}put-away/`);
  }

  updateGRNLinesShelf(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/categories/`,
      data,
    );
  }

  getPrefilledLines(grnId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${grnId}/prefilled-lines/`,
    );
  }

  getGrnLineExport(grnId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${grnId}/lines/export/`,
    );
  }
}

export default new GrnApi();
